module.exports = __webpack_public_path__ + "img/8.18c175a2.png";